// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3e6f92bf","239":"7dfc9a59","453":"b56ae87c","455":"36147671"}[chunkId] + ".chunk.js";
};